import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  successResponse: {},
  isLoading: false,
  isError: false,
  error: false
};
const refundAirFareFeeRequestSlice = createSlice({
  name: "refundAirFareFeeRequest",
  initialState,
  reducers: {
    refundAirFareFeeRequest: (state, action) => {
      state.isLoading = true;
      state.error = false;
      state.isError = false;
    },
    refundAirFareFeeRequestSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.successResponse = action.payload;
    },
    refundAirFareFeeRequestFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.isError = true;
    },
    clearRefundAirFareFeeRequestData: state => {
      state.error = "";
      state.hasData = false;
      state.successResponse = {};
      state.isError = false;
    },
    fdCompensationRequest: (state, action) => {
      state.isLoading = true;
      state.error = false;
      state.isError = false;
    },
    fdCompensationSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.successResponse = action.payload;
    },
    fdCompensationFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.isError = true;
    },
    clearfdRequestData: state => {
      state.error = "";
      state.hasData = false;
      state.successResponse = {};
      state.isError = false;
    }
  }
});
export const {
  refundAirFareFeeRequest,
  refundAirFareFeeRequestSuccess,
  refundAirFareFeeRequestFailure,
  clearRefundAirFareFeeRequestData,
  fdCompensationRequest,
  fdCompensationSuccess,
  fdCompensationFailure,
  clearfdRequestData
} = refundAirFareFeeRequestSlice.actions;
export default refundAirFareFeeRequestSlice.reducer;